import React from 'react'
import PropTypes from 'prop-types'
import { FormHelperText, Collapse, useFormControlContext } from '@chakra-ui/react'

export const FormInputLength = React.forwardRef(({ length, max, ...rest }, ref) => {
  const field = useFormControlContext()

  return (
    <Collapse in={field?.isInvalid || field?.isFocused} animateOpacity>
      <FormHelperText
        ref={ref}
        marginLeft='auto'
        justifyContent='flex-end'
        display='flex'
        lineHeight='1.75'
        fontSize='xs'
        color={field?.isInvalid ? 'red.500' : null}
        {...rest}
      >
        {typeof max === 'number' ? `${length} / ${max}` : length}
      </FormHelperText>
    </Collapse>
  )
})

FormInputLength.propTypes = {
  length: PropTypes.number.isRequired,
  max: PropTypes.number,
}
